import { render } from "./HeroiconsSolidServer.vue?vue&type=template&id=6942e04b"
const script = {}

import exportComponent from "/Users/administrator/Sites/HengFuTong/extends/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidServer.vue"]])

export default __exports__